import { render, staticRenderFns } from "./dna.vue?vue&type=template&id=3e4993f4&scoped=true&"
import script from "./dna.vue?vue&type=script&lang=js&"
export * from "./dna.vue?vue&type=script&lang=js&"
import style0 from "./dna.vue?vue&type=style&index=0&id=3e4993f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4993f4",
  null
  
)

export default component.exports